var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper" }, [
    _c(
      "div",
      { staticClass: "main-panel" },
      [
        _c("top-navbar"),
        _vm._v(" "),
        _c("dashboard-content", { on: { click: _vm.toggleSidebar } }),
        _vm._v(" "),
        _c("content-footer")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }